import React, { cloneElement } from "react";

import Link from "gatsby-link";

export default class Breadcrumbs extends React.Component {
  render() {
    let { crumbs } = this.props;

    crumbs = crumbs.map((crumb) => {
      if (typeof crumb === "string") {
        return <span className="breadcrumb-current">{crumb}</span>;
      }

      const name = Object.keys(crumb)[0];
      const to = crumb[name];

      return (
        <Link to={to} title={name}>
          {name}
        </Link>
      );
    });

    for (let i = crumbs.length - 1; i > 0; i--) {
      crumbs.splice(i, 0, <span className="breadcrumb-separator">&gt;</span>);
    }

    crumbs = crumbs.map((crumb, index) => cloneElement(crumb, { key: index }));

    return <nav id="breadcrumbs" children={crumbs} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/breadcrumbs.js